import { defTitle } from 'assets/strings';
import FormGenerator from 'components/Form/template/FormGenerator';
import SimplesForm from 'components/modal/template/simplesForm';
import React, { FC, memo, useEffect } from 'react';

const ComponentConfiguracaoSaque: FC<any> = memo(oProps => {
    useEffect(() => {
        document.title = `${defTitle} - Configurações de saque`;
    }, []);

    return (
        <SimplesForm
            widthModal="80rem"
            rForm={oProps.rForm}
            handleSubmit={oProps.handleSubmit}
            loading={oProps.loading}
            titleSubmit={'Salvar'}
            loadingData={oProps.loadingData}
            titleModal={'Configurações de saque'}
            message={null}>
            {!oProps.loadingData && (
                <FormGenerator
                    rForm={oProps.rForm}
                    childs={[
                        {
                            gridColumn: '1fr 1fr 1fr 1fr',
                            items: [
                                {
                                    type: 'select-simple',
                                    label: 'Saque do entregador',
                                    name: 'Saque_Ativo',
                                    toolTipLegend: 'Libera a solicitação de saque no app do entregador',
                                    options: [
                                        {
                                            label: 'Ativado',
                                            value: '1',
                                        },
                                        {
                                            label: 'Desativado',
                                            value: '0',
                                        },
                                    ],
                                    defaultValue:
                                        oProps.defaultValues['Saque_Ativo'] ||
                                        '0',
                                },
                                {
                                    type: 'select-simple',
                                    label: 'Aprovação do saque',
                                    name: 'Saque_Aprovacao_Manual',
                                    toolTipLegend: 'Manual: o saque só é pago depois de aprovado em Saques. Automática: o PIX é enviado na hora',
                                    options: [
                                        {
                                            label: 'Manual',
                                            value: '1',
                                        },
                                        {
                                            label: 'Automática',
                                            value: '0',
                                        },
                                    ],
                                    defaultValue:
                                        oProps.defaultValues['Saque_Aprovacao_Manual'] ||
                                        '1',
                                },
                                {
                                    type: 'money',
                                    label: 'Valor mínimo do saque',
                                    toolTipLegend: 'Valor mínimo que o entregador pode solicitar',
                                    placeholder: 'Digite aqui o valor',
                                    name: 'Saque_Valor_Minimo',
                                    defaultValue:
                                        oProps.defaultValues['Saque_Valor_Minimo'],
                                },
                                {
                                    type: 'text',
                                    label: 'Data de corte do saque',
                                    toolTipLegend: 'Só corridas e turnos a partir desta data entram no saldo do app. O que veio antes é pago pelo financeiro',
                                    placeholder: 'AAAA-MM-DD',
                                    name: 'Saque_Data_Corte',
                                    defaultValue:
                                        oProps.defaultValues['Saque_Data_Corte'],
                                },
                            ],
                        },
                        {
                            gridColumn: '1fr 1fr 1fr 1fr',
                            items: [
                                {
                                    type: 'number',
                                    label: 'Retenção do saque (dias)',
                                    toolTipLegend: 'Dias após a corrida em que o valor ainda não pode ser sacado. 0 libera na hora',
                                    placeholder: 'Ex: 1',
                                    name: 'Saque_Retencao_Dias',
                                    defaultValue:
                                        oProps.defaultValues['Saque_Retencao_Dias'] || '0',
                                },
                                {
                                    type: 'number',
                                    label: 'Prazo padrão (dias)',
                                    toolTipLegend: 'Saque de corrida com menos dias que este prazo paga a taxa de antecipação',
                                    placeholder: 'Ex: 7',
                                    name: 'Saque_Prazo_Padrao_Dias',
                                    defaultValue:
                                        oProps.defaultValues['Saque_Prazo_Padrao_Dias'] || '0',
                                },
                                {
                                    type: 'select-simple',
                                    label: 'Tipo da taxa de antecipação',
                                    name: 'Saque_Taxa_Antecipacao_Tipo',
                                    toolTipLegend: 'Percentual sobre o valor antecipado ou valor fixo por saque',
                                    options: [
                                        {
                                            label: 'Percentual (%)',
                                            value: 'percentual',
                                        },
                                        {
                                            label: 'Valor fixo (R$)',
                                            value: 'fixo',
                                        },
                                    ],
                                    defaultValue:
                                        oProps.defaultValues['Saque_Taxa_Antecipacao_Tipo'] ||
                                        'percentual',
                                },
                                {
                                    type: 'money',
                                    label: 'Taxa de antecipação',
                                    toolTipLegend: 'Percentual (ex: 2.50) ou valor fixo em reais (ex: 2.50), conforme o tipo. 0 não cobra taxa',
                                    placeholder: 'Digite aqui o valor',
                                    name: 'Saque_Taxa_Antecipacao_Valor',
                                    defaultValue:
                                        oProps.defaultValues['Saque_Taxa_Antecipacao_Valor'],
                                },
                            ],
                        },
                    ]}
                />
            )}
        </SimplesForm>
    );
});
export default ComponentConfiguracaoSaque;
